export default "__VITE_ASSET__1c3a571d__"